import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';

class FormStore {
  data = {};
  error = {};
  errors = [];
  originData = {};

  constructor(parentStore) {
    makeObservable(this, {
      data: observable,
      error: observable,
      errors: observable,
      originData: observable,
      handlerInput: action,
      handlerTextarea: action,
      handlerCheckbox: action,
      handlerCheckboxes: action,
      handlerRating: action,
      handlerReactSelect: action,
      handlerDateInput: action,
      handlerTimestamp: action,
      handlerRadio: action,
      rollbackData: action,
      setField: action,
      addError: action,
    });

    this.parentStore = parentStore;
  }

  handlerInput = (event) => {
    if (event.target && event.target.name && event.target.checked) {
      _.set(this.data, event.target.name, event.target.checked);
    } else if (event.target && event.target.name && event.target.value !== undefined) {
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
  };

  handlerTextarea = (event) => {
    if (event.target && event.target.name && event.target.value !== undefined) {
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
  };

  handlerCheckbox = (event) => {
    _.set(this.data, event.target.name, event.target.checked);
  };

  handlerCheckboxes = (event) => {
    const currentValue = this.getField(event.target.name, []);
    if (event.target.checked === true && !currentValue.includes(event.target.value)) {
      currentValue.push(event.target.value);
      _.set(this.data, event.target.name, currentValue);
    } else if (event.target.checked === false && currentValue.includes(event.target.value)) {
      _.remove(currentValue, function (str) {
        return str === event.target.value;
      });

      _.set(this.data, event.target.name, currentValue);
    }
  };

  handlerRating = (name) => (value) => {
    _.set(this.data, name, value);
    _.set(this.data, 'tags', []);
  };

  handlerReactSelect = (name) => (option) => {
    this.data[name] = option.value;
  };

  handlerDateInput = (name) => (date) => {
    this.data[name] = date;
  };

  handlerTimestamp = (name) => (date) => {
    if (date) {
      this.data[name] = date.getTime();
    }
  };

  getField(name, defaultValue) {
    return _.get(this.data, name, defaultValue);
  }

  arrayContains(name, value) {
    return _.get(this.data, name, []).includes(value);
  }

  setField(name, value) {
    return _.set(this.data, name, value);
  }

  addError(error) {
    this.errors = [error];
  }

  getErrors() {
    return this.errors;
  }

  handlerRadio = (evt) => {
    _.set(this.data, evt.target.name, [evt.target.value]);
  };

  rollbackData = () => {
    this.data = _.cloneDeep(this.originData);
  };
}

export default FormStore;
